<template>
  <GlobalHead>
    <router-view></router-view>
  </GlobalHead>
</template>

<script>
import GlobalHead from './components/GlobalHead.vue';

export default {
  name: 'App',
  components: {
    GlobalHead
  }
}
</script>
